import { Button } from "@/components/core/buttons/button";
import { Form, FormDescription } from "@/components/core/forms/form.tsx";
import {
	FormField,
	FormGroup,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/core/forms/form.tsx";
import { Input } from "@/components/core/forms/input";
import { Textarea } from "@/components/core/forms/textarea";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { formatDate } from "@/utils/format-date";
import { useForm } from "react-hook-form";
import { useArticleMutation } from "../api/queries/article-query";
import type { Article } from "../types/article";

export default function ArticleRejectModal({ data }: { data: Article }) {
	const { closeModal } = useModalControl();
	const form = useForm({
		defaultValues: {
			remarks: "",
			status: "Rejected",
		},
	});

	const articleMutation = useArticleMutation(data?.id);

	return (
		<Form {...form}>
			<div className="w-full">
				<div className="grid grid-cols-12 w-full gap-3">
					<div className="col-span-12 w-full">
						<div className="col-span-12 w-full">
							<div className="flex flex-row w-full gap-4">
								<div className="flex flex-col w-full gap-2">
									<div className="flex flex-col w-full">
										<span className="text-base text-foreground/70">Title</span>
										<span className="text-base font-semibold text-foreground-dark uppercase">
											{data?.title}
										</span>
									</div>

									<div className="flex flex-col w-full">
										<span className="text-base text-foreground/70">Author</span>
										<span className="text-base font-semibold text-foreground-dark">
											{data.author}
										</span>
									</div>

									<div className="flex flex-col w-full">
										<span className="text-base text-foreground/70">
											Date Submitted
										</span>
										<span className="text-base font-semibold text-foreground-dark">
											{formatDate(data?.created_at, "PPp")}
										</span>
									</div>

									<div className="col-span-12 flex flex-col w-full">
										<FormField
											control={form.control}
											name="remarks"
											render={({ field }) => (
												<FormItem>
													<div className="flex flex-col w-full">
														<FormLabel required>Remarks</FormLabel>
													</div>
													<FormGroup>
														<Textarea
															autoComplete="off"
															placeholder="Type your remarks here..."
															{...field}
														/>
													</FormGroup>
													{/* <FormMessage>
                            Yes, error message is here aside from alert box
                          </FormMessage> */}
												</FormItem>
											)}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="flex flex-row justify-between w-full gap-4 mt-6">
					<Button
						className=""
						variant="danger"
						type="button"
						onClick={async () => {
							await articleMutation.mutateAsync({
								...data,
								status: "Rejected",
								remarks: form.getValues("remarks"),
							});
							closeModal();
						}}
					>
						Reject
					</Button>
					<Button
						className=""
						variant="ghost"
						type="button"
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</Button>
				</div>
			</div>
		</Form>
	);
}
